import classNames from 'classnames';

import { LANG_ENV } from 'config/env';

import type { AnalyticsEvent, EventProps } from './general';

interface PlausibleEventProps extends EventProps {}

export const pushPlausibleEvent = (eventName: AnalyticsEvent, props?: PlausibleEventProps) => {
    if (typeof window === 'undefined' || !window.plausible) {
        return;
    }

    window.plausible(eventName, { props: props });
};

export const getPlausibleDomain = () => {
    if (process.env.GATSBY_ENV === 'development' || process.env.NODE_ENV === 'development') {
        switch (LANG_ENV) {
            case 'en':
                return 'web2020-development.ackee.agency';
            case 'de':
                return 'web2020-development.ackee.de';
            default:
                return 'web2020-development.ack.ee';
        }
    }
    switch (LANG_ENV) {
        case 'en':
            return 'ackee.agency';
        case 'de':
            return 'ackee.de';
        default:
            return 'ackee.cz';
    }
};

export const getPlausibleClassName = (className: string, eventName: AnalyticsEvent, props?: PlausibleEventProps) => {
    const plausibleClassName = classNames(
        className,
        eventName ? `plausible-event-name=${eventName}` : null,
        props ? Object.entries(props).map(([key, value]) => `plausible-event-${key}=${value}`) : null,
    );

    return plausibleClassName;
};
